export class NextReviewDateModel {
    reviewId: number;
    nextReviewDate: string;
}